import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import history from './utils/history';
import configureStore from './store/configureStore';
import {withRouter, BrowserRouter} from 'react-router-dom';
import './index.css';
import {App} from './containers/App';
import reportWebVitals from './reportWebVitals';
import registerServiceWorker from './registerServiceWorker';
import { SnackbarProvider } from 'notistack';
import ErrorBoundary from './errorBoundary.js'
import CacheBuster from 'react-cache-buster';
import packageInfo from '../package.json';

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);
//var store = createStore(reducer);

store.dispatch({ 
  type: "INITIAL_STATE",
  state: {
    currentTeam : null,
    currentOrg: null
  }
});

const rootElement = document.getElementById('root');
const isProduction = process.env.NODE_ENV === 'production';
console.log("isProd:" + isProduction)
console.log("version:" + packageInfo.version)
ReactDOM.render(
  <CacheBuster
      currentVersion={packageInfo.version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
     // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
    >
  <Provider store={store}>
    <BrowserRouter history={history}> 
    <ConnectedRouter history={history}>

      {/* <MuiPickersUtilsProvider utils={MomentUtils}> */}
        <SnackbarProvider>
          <ErrorBoundary>
          <App />
          </ErrorBoundary>
        </SnackbarProvider>
      {/* </MuiPickersUtilsProvider> */}
    </ConnectedRouter>
    </BrowserRouter> 
  </Provider></CacheBuster>,
  rootElement);

registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
